import React from 'react';

export const Card = React.memo(({ fill }) => (
  <>
    <g transform={'translate(' + 2 + ',' + 2 + ')'}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={30 - 2 * 2}
        height={30 - 2 * 2}
        viewBox={'0 0 30 30'}
        fill={'none'}
      >
        <path
          d='M7.5 17.813a0.937 0.937 0 0 0 0 1.876zm4.375 1.876a0.937 0.937 0 0 0 0 -1.876zM6.25 8.438h17.5V6.563H6.25zm19.063 1.561v10h1.876V10zm-1.562 11.563H6.25v1.876h17.5zM4.687 20V10H2.812v10zm1.562 1.562a1.56 1.56 0 0 1 -1.562 -1.562H2.812a3.438 3.438 0 0 0 3.438 3.437zm19.063 -1.562c0 0.863 -0.7 1.562 -1.562 1.562v1.876a3.438 3.438 0 0 0 3.437 -3.438zm-1.562 -11.563c0.863 0 1.562 0.7 1.562 1.562h1.876a3.438 3.438 0 0 0 -3.438 -3.437zM6.25 6.563a3.438 3.438 0 0 0 -3.437 3.437h1.876c0 -0.863 0.7 -1.562 1.562 -1.562zm-2.5 6.875h22.5V11.562H3.75zm3.75 6.25h4.375v-1.876H7.5z'
          fill={fill}
        />
      </svg>
    </g>
  </>
));
Card.displayName = 'Card';
